export default "__VITE_ASSET__BYICVgld__"